/**
 * ファイルが存在するか調べる
 */
module.exports = function( path ){
    var fs = require('fs');
    if( !fs.existsSync(path) || !fs.statSync(path).isFile() ){
        return false;
    }
    return true;
}
